"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAllProjects = useAllProjects;
exports.allProjectsQueryFn = void 0;

var _reactQuery = require("react-query");

var _client = require("../../client");

var _createKey = require("./createKey");

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var allProjectsQueryFn = _client.Api.fetchAllProjects;
exports.allProjectsQueryFn = allProjectsQueryFn;
var defaultConfigValues = {
  keepPreviousData: true
};

function useAllProjects(input) {
  var _input$queryFn;

  var key = (0, _createKey.createAllProjectsKey)();
  var queryFn = (_input$queryFn = input === null || input === void 0 ? void 0 : input.queryFn) !== null && _input$queryFn !== void 0 ? _input$queryFn : allProjectsQueryFn;

  var config = _objectSpread(_objectSpread({}, defaultConfigValues), input === null || input === void 0 ? void 0 : input.config);

  var _useQuery = (0, _reactQuery.useQuery)(key, queryFn, config),
      projects = _useQuery.data,
      queryInfo = _objectWithoutProperties(_useQuery, ["data"]);

  return _objectSpread(_objectSpread({}, queryInfo), {}, {
    projects: projects
  });
}